import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import { Navigation, Footer } from "@/components/sections";

export const ImpressumPage = () => {
  const { t } = useTranslation();
  
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>Impressum - ForestHub</title>
        <meta name="description" content="Impressum und rechtliche Informationen zu ForestHub" />
      </Helmet>
      
      <Navigation onRequestDemo={() => {}} />
      
      <div className="pt-28 pb-24 max-w-3xl mx-auto px-6">
        <h1 
          className="text-3xl font-semibold text-stone-900 mb-8" 
          style={{ fontFamily: 'Outfit, sans-serif' }}
        >
          {t('legal.impressum.title')}
        </h1>
        
        <div className="prose prose-stone max-w-none">
          <h2>{t('legal.impressum.according')}</h2>
          
          <h3>{t('legal.impressum.operator')}</h3>
          <p>
            <strong>Hodema edertools AB</strong><br />
            Kyrkvägen 66<br />
            88372 Backe<br />
            Sweden
          </p>
          
          <h3>{t('legal.impressum.contact')}</h3>
          <p>
            E-Mail: <a href="mailto:info@hodema.se">info@hodema.se</a><br />
            Website: <a href="https://www.hodema.se" target="_blank" rel="noopener noreferrer">www.hodema.se</a>
          </p>
          
          <h3>{t('legal.impressum.responsible')}</h3>
          <p>Hodema edertools AB, Kyrkvägen 66, 88372 Backe, Sweden</p>
          
          <h2>{t('legal.impressum.disclaimer')}</h2>
          <p>{t('legal.impressum.disclaimerText')}</p>

          <h2>{t('legal.impressum.links')}</h2>
          <p>{t('legal.impressum.linksText')}</p>

          <h2>{t('legal.impressum.copyright')}</h2>
          <p>{t('legal.impressum.copyrightText')}</p>
        </div>
        
        <div className="mt-12">
          <a href="/" className="text-[#1B4D3E] font-medium hover:underline">
            ← {t('legal.impressum.back')}
          </a>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};
